import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import type {
  AcceptTermsAndConditionsRequest,
  CompleteFirstInstallOnboardingRequest,
  CompleteFirstInstallOnboardingResponse,
  Onboarding,
  TcAcceptResponse,
} from "@redotech/redo-model/onboarding";

export async function getCurrentOnboarding(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<Onboarding> {
  const response = await client.client.get("onboarding", {
    headers: client.authorization(),
    params: { _t: Date.now() },
    signal,
  });
  return response.data;
}

export async function onboardingTc(
  client: RedoMerchantClient,
  {
    firstInstallOnboardingVersion,
    signal,
  }: AcceptTermsAndConditionsRequest & { signal?: AbortSignal } = {},
): Promise<TcAcceptResponse> {
  const response = await client.client.put(
    "onboarding/tc",
    firstInstallOnboardingVersion ? { firstInstallOnboardingVersion } : {},
    { headers: client.authorization(), signal },
  );
  return response.data;
}

export async function completeFirstInstallOnboarding(
  client: RedoMerchantClient,
  input: CompleteFirstInstallOnboardingRequest,
  { signal }: { signal?: AbortSignal } = {},
): Promise<CompleteFirstInstallOnboardingResponse> {
  const response = await client.client.post(
    "onboarding/first-install/complete",
    input,
    { headers: client.authorization(), signal },
  );
  return response.data;
}
